import z from 'zod'
import { capitalize } from './utils'

export const LanguageCodes = [
  'de',
  'en',
  'es',
  'fr',
  'it',
  'ja',
  'pl',
  'ru',
  'tr',
  // For showing keys in dev mode
  'dev',
] as const

export const defaultNamespace = 'translation'

export type LanguageCode = (typeof LanguageCodes)[number]

export const languageCodeSchema = z.enum(LanguageCodes)

export const displayLanguageNameByCode = (
  code: LanguageCode,
  locale: string
) => {
  const languageNames = new Intl.DisplayNames([locale], { type: 'language' })
  return languageNames.of(code)
}

export const getLanguageName = (code: LanguageCode) =>
  capitalize(displayLanguageNameByCode(code, `${code}`))

export const getLanguageNameTranslated = (code: LanguageCode, locale: string) =>
  capitalize(displayLanguageNameByCode(code, locale))
